import { Flex, Progress, Text, Box, Skeleton } from "@chakra-ui/react";
import CardDefault from "ui/components/Cards/CardDefault";
import { AiFillEye } from "react-icons/ai";
import { Row } from "antd";
import ModalVotantes from "../ModalVotantes";
import { useState } from "react";
import { trackEvent } from "infra/helpers/event";

interface ResultadoPerguntaProps {
  perguntaId: string;
  votacaoId: string;
  totalVotos: number | undefined;
  totalNaoVotaram: number | undefined;
  totalParticipantes: number | undefined;
  isLoading?: boolean;
}
function ResultadoPergunta({
  perguntaId,
  votacaoId,
  totalVotos,
  totalNaoVotaram,
  totalParticipantes,
  isLoading,
}: ResultadoPerguntaProps) {
  const [modalVotantesOpen, setVotacaoOpen] = useState(false);

  function handleModal() {
    trackEvent(`Votacao_Participantes_Visualizar`);
    setVotacaoOpen(true);
  }

  const percentVotaram =
    totalParticipantes !== undefined && totalVotos !== undefined
      ? (totalVotos * 100) / totalParticipantes
      : 0;
  const percentNaoVotaram =
    totalParticipantes !== undefined && totalNaoVotaram !== undefined
      ? (totalNaoVotaram * 100) / totalParticipantes
      : 0;

  if (isLoading) {
    return <Skeleton h="110px" w="100%" mb="5" rounded="16px" />;
  }

  return (
    <CardDefault
      mb="5"
      w="100%"
      height="110px"
      p="2"
      justifyContent="space-around"
    >
      <Box as={Row}>
        <Flex flexDirection="column" w="280px">
          <Text fontSize={14} m="1">
            {totalVotos}{" "}
            {totalVotos !== 1 ? "unidades já votaram" : "unidade já votou"}
            <Progress
              value={percentVotaram}
              mb="1"
              mt="1"
              colorScheme="green"
              size="xs"
            />
          </Text>
          <Text fontSize={14} m="1">
            {totalNaoVotaram}{" "}
            {totalNaoVotaram !== 1
              ? "unidades não votaram"
              : "unidade não votou"}{" "}
            ainda
            <Progress
              value={percentNaoVotaram}
              mt="1"
              colorScheme="green"
              size="xs"
            />
          </Text>
        </Flex>
        <Flex flexDirection="column" ml="2">
          <AiFillEye
            size={22}
            color="#B5BECD"
            onClick={handleModal}
            cursor="pointer"
          />
        </Flex>
      </Box>

      {modalVotantesOpen ? (
        <ModalVotantes
          isOpen={modalVotantesOpen}
          onClose={() => setVotacaoOpen(false)}
          perguntaId={perguntaId}
          votacaoId={votacaoId}
        />
      ) : null}
    </CardDefault>
  );
}

export default ResultadoPergunta;
